module.exports = {"street_name":"Street name","select_street":"Select street below","enter_street_name":"Enter street name","search_street_name":"Search street name"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/street.json
// module id = 656
// module chunks = 247 1425